/* =========================================================
   UNIVERSAL SHOPIFY WISHLIST — SESEMIIYA (STABLE BUILD)
   Compatible: Monza, Dawn, Lyra, Prestige, Impulse, Warehouse
========================================================= */

const WISHLIST_KEY = 'shopify_wishlist';


/* =========================================================
   HARD BLOCK CARD NAVIGATION
========================================================= */

window.addEventListener('mousedown', function(e){
  if(e.target.closest('.wishlist-heart') || e.target.closest('.wishlist-remove')){
    e.stopPropagation();
  }
}, true);


/* =========================================================
   STORAGE
========================================================= */

function getWishlist(){
  try{
    return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  }catch{
    return [];
  }
}

function saveWishlist(list){
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  updateWishlistCount();
}


/* =========================================================
   HEADER COUNT
========================================================= */

function updateWishlistCount(){
  const count = getWishlist().length;

  document.querySelectorAll('.wishlist-count').forEach(el=>{
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}


/* =========================================================
   HEART STATE
========================================================= */

function setHeartState(heart, handle){
  if(getWishlist().includes(handle)){
    heart.classList.add('active');
    heart.innerHTML = '♥';
  }else{
    heart.classList.remove('active');
    heart.innerHTML = '♡';
  }
}

function syncAllHearts(){
  document.querySelectorAll('.wishlist-heart').forEach(heart=>{
    setHeartState(heart, heart.dataset.handle);
  });
}


/* =========================================================
   PRODUCT CARD HEART INJECTION
========================================================= */

function injectHearts(){

  const productLinks = document.querySelectorAll(
    '.product-card a[href*="/products/"]'
  );

  productLinks.forEach(link=>{

    const handle = link.pathname.split('/products/')[1]?.split('?')[0];
    if(!handle) return;

    const wrapper =
      link.closest('.product-card') ||
      link.parentElement;

    if(!wrapper || wrapper.querySelector('.wishlist-heart')) return;

    const heart = document.createElement('button');
    heart.type = "button";
    heart.className = 'wishlist-heart';
    heart.dataset.handle = handle;

    setHeartState(heart, handle);

    heart.addEventListener('click', function(e){

      e.preventDefault();

      let list = getWishlist();

      if(list.includes(handle)){
        list = list.filter(h=>h!==handle);
      }else{
        list.push(handle);
      }

      saveWishlist(list);
      syncAllHearts();
    });

    wrapper.style.position = 'relative';
    wrapper.appendChild(heart);

  });
}


/* =========================================================
   PRODUCT PAGE BUTTON
========================================================= */

function productPageButton(){

  const form = document.querySelector('form[action*="/cart/add"]');
  if(!form) return;

  if(document.querySelector('.wishlist-product-btn')) return;

  const handle = location.pathname.split('/products/')[1]?.split('?')[0];
  if(!handle) return;

  const btn = document.createElement('button');
  btn.type = "button";
  btn.className = 'wishlist-product-btn';

  function render(){
    if(getWishlist().includes(handle)){
      btn.textContent = '♥ Added to Wishlist';
    }else{
      btn.textContent = '♡ Add to Wishlist';
    }
  }

  btn.addEventListener('click', function(){

    let list = getWishlist();

    if(list.includes(handle)){
      list = list.filter(h=>h!==handle);
    }else{
      list.push(handle);
    }

    saveWishlist(list);
    render();
    syncAllHearts();
  });

  form.after(btn);
  render();
}


/* =========================================================
   WISHLIST PAGE RENDER
========================================================= */

async function renderWishlistPage(){

  const container = document.querySelector('#wishlist-container');
  const emptyBox = document.querySelector('#wishlist-empty');

  if(!container) return;

  const list = getWishlist();

  /* EMPTY STATE */

  if(!list.length){

    if(container) container.style.display = "none";

    if(emptyBox){
      emptyBox.style.display = "block";
    }else{
      container.innerHTML =
        '<p class="wishlist-empty">Your wishlist is waiting… go fall in love with something ✨ <a href="/">Continue shopping</a></p>';
      container.style.display = "block";
    }

    return;
  }

  if(emptyBox) emptyBox.style.display = "none";
  container.style.display = "grid";

  container.innerHTML = '';

  for(const handle of list){

    try{
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();

      const item = document.createElement('div');
      item.className = 'wishlist-item';

      item.innerHTML = `
        <a href="/products/${handle}">
          <img loading="lazy" src="${product.images[0]}" class="wishlist-img">
        </a>
        <a href="/products/${handle}" class="wishlist-title">${product.title}</a>
        <p class="wishlist-price">₹ ${(product.price/100).toLocaleString()}</p>
        <div class="wishlist-actions">
          <a href="/products/${handle}" class="view">View Product</a>
          <button type="button" class="wishlist-remove" data-handle="${handle}">Remove</button>
        </div>
      `;

      container.appendChild(item);

    }catch(err){}
  }

  /* REMOVE WITHOUT REFRESH */

  container.querySelectorAll('.wishlist-remove').forEach(btn=>{
    btn.addEventListener('click', function(){

      const handle = this.dataset.handle;

      let list = getWishlist().filter(h=>h!==handle);

      saveWishlist(list);

      this.closest('.wishlist-item').remove();

      updateWishlistCount();
      syncAllHearts();

      if(!list.length){
        renderWishlistPage();
      }

    });
  });

}


/* =========================================================
   INIT
========================================================= */

function wishlistInit(){
  updateWishlistCount();
  injectHearts();
  productPageButton();
  renderWishlistPage();
}

document.addEventListener('DOMContentLoaded', wishlistInit);


/* =========================================================
   SHOPIFY OS 2.0 SUPPORT
========================================================= */

document.addEventListener('shopify:section:load', injectHearts);
document.addEventListener('shopify:section:reorder', injectHearts);
document.addEventListener('shopify:navigation:complete', injectHearts);

window.addEventListener('pageshow', ()=>{
  injectHearts();
  syncAllHearts();
});

//Product Share Btn JS

document.addEventListener("DOMContentLoaded", function(){

const url = window.location.href;
const title = document.title;

const fb = document.querySelector(".share-icon.facebook");
const wa = document.querySelector(".share-icon.whatsapp");
const ig = document.querySelector(".share-icon.instagram");
const more = document.querySelector(".share-more");

if(fb)
fb.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

if(wa)
wa.href = `https://wa.me/?text=${encodeURIComponent(title + " " + url)}`;

if(ig)
ig.href = "https://instagram.com/"; 

if(more){
more.addEventListener("click", async () => {

if(navigator.share){
await navigator.share({
title: title,
url: url
});
}else{
navigator.clipboard.writeText(url);
alert("Link copied");
}

});
}

});





///////Client Marquee Javascript//////

document.addEventListener("DOMContentLoaded", () => {

    const speed = window.innerWidth < 768 ? 0.35 : 0.6;

    function createMarquee(selector, direction){

        const row = document.querySelector(selector);

        if(!row) return;

        const track = row.querySelector(".nh-track");

        // Clone only once
        if(!track.dataset.ready){

            track.innerHTML += track.innerHTML;

            track.dataset.ready = "true";

        }

        let x = direction === -1 ? 0 : -(track.scrollWidth / 2);

        let paused = false;

        row.addEventListener("mouseenter", () => paused = true);

        row.addEventListener("mouseleave", () => paused = false);

        function loop(){

            if(!paused){

                x += speed * direction;

                const limit = track.scrollWidth / 2;

                if(direction === -1 && x <= -limit){

                    x = 0;

                }

                if(direction === 1 && x >= 0){

                    x = -limit;

                }

                track.style.transform = `translate3d(${x}px,0,0)`;

            }

            requestAnimationFrame(loop);

        }

        loop();

    }

    createMarquee(".nh-row-1",-1);

    createMarquee(".nh-row-2",1);

});